
import {Component, Input, Output, EventEmitter} from '@angular/core';


@Component({
  selector: 'calendar-create-type',
  templateUrl: './calendar-create-type.component.html',
  styleUrls: ['./calendar-create-type.component.css']
})
export class CalendarCreateTypeComponent {

  heading : string;
  glyphiconForHeading : string;
  maxPlaceholder : string;
  isMaxDisabled : boolean;

  @Output() primaryQuestionEntered = new EventEmitter<string>();
  @Output() secondaryQuestionEntered = new EventEmitter<string>();
  @Output() isRequiredChanged = new EventEmitter<boolean>();
  @Output() typeOfCalendar = new EventEmitter<string>();

  ngOnInit() : void{
    this.heading = "Calendar";
    this.glyphiconForHeading = "glyphicon glyphicon-calendar";
    this.maxPlaceholder = "Maximum Characters";
    this.isMaxDisabled = true;

  }
  questionPrimaryEnter(event : any){
    this.primaryQuestionEntered.emit(event.target.value);
  }

  questionSecondaryEnter(event : any){
    this.secondaryQuestionEntered.emit(event.target.value);
  }

  requiredChanged(event : boolean){

    this.isRequiredChanged.emit(event);
  }

  calendarTypeSelected(type : string){
    this.typeOfCalendar.emit(type);
  }



}



// WEBPACK FOOTER //
// ./src/app/oldCentralPannel/calendar-type/calendar-type.component.ts